import { useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import { toast } from "react-toastify";

const ProfileManagement = () => {
    // Retrieve stored values from localStorage
    const storedUsername = localStorage.getItem("username") || "";
    const storedEmail = localStorage.getItem("email") || "";

    const [username, setUsername] = useState(storedUsername);
    const [email, setEmail] = useState(storedEmail);

    // Handle profile edits
    const handleProfileSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axiosInstance.post("/user/editProfile", { username, email });
            if (response.status === 200) {
                localStorage.setItem("username", username);
                localStorage.setItem("email", email);
                toast.success("Profile updated successfully!");
            } else {
                toast.error(response.data.message || "Failed to update profile.");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "An error occurred.");
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center p-4">
            <h1 className="text-4xl font-extrabold mb-6 text-gray-800 border-b pb-4 text-center">
                Profile
            </h1>

            <div className="w-full flex justify-center">
                <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                    {/* <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">Profile Info</h2> */}
                    <form onSubmit={handleProfileSubmit} className="space-y-4">
                        <div>
                            <label htmlFor="username" className="block text-gray-700">
                                Username
                            </label>
                            <input
                                type="text"
                                id="username"
                                className="w-full p-2 mt-2 border border-gray-300 rounded"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                disabled
                            />
                        </div>

                        <div>
                            <label htmlFor="email" className="block text-gray-700">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                className="w-full p-2 mt-2 border border-gray-300 rounded"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled
                            />
                        </div>

                        {/* <div className="mt-4">
                            <button
                                type="submit"
                                className="w-full p-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                            >
                                Save
                            </button>
                        </div> */}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ProfileManagement;
